import { useState } from "react";

import { ScrollablePane, ShimmeredDetailsListProps } from "@bps/fluent-ui";
import { Selector } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { EvaluateSelectorDialog } from "./dialogs/evaluate/EvaluateSelectorDialog";
import { SelectorsTable } from "./SelectorsTable";

interface SelectorsProps extends ShimmeredDetailsListProps {}

export const Selectors = ({ ...props }: SelectorsProps) => {
  const [selector, setSelector] = useState<Selector>();

  return (
    <ScrollablePane styles={{ root: { height: "90%", position: "relative" } }}>
      <SelectorsTable
        setSelector={setSelector}
        selectionPreservedOnEmptyClick
        setKey="selector-package-table"
        {...props}
      />
      <EvaluateSelectorDialog
        onDismiss={() => setSelector(undefined)}
        hidden={!selector}
        selector={selector ?? ({} as Selector)}
      />
    </ScrollablePane>
  );
};
